import { render, staticRenderFns } from "./loginPage.vue?vue&type=template&id=3804ae82&scoped=true&"
import script from "./loginPage.vue?vue&type=script&lang=js&"
export * from "./loginPage.vue?vue&type=script&lang=js&"
import style0 from "./loginPage.vue?vue&type=style&index=0&id=3804ae82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3804ae82",
  null
  
)

export default component.exports